/**
 * Shop By Bike — navegação Marca > Modelo > Ano.
 *
 * Todos os níveis já vêm renderizados no HTML pela section; este script apenas
 * decide qual deles fica visível, a partir da query string. O Liquid do Shopify
 * não lê parâmetros de URL, por isso a troca de nível acontece no cliente.
 *
 * Sem JS, o nível de marcas continua visível e os links funcionam como
 * navegação normal (cada um é um href real).
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'hauer:selected-bike';

  function init(root) {
    // No theme editor a section é recarregada várias vezes; sem esta trava o mesmo root
    // ganharia um novo listener de clique e de popstate a cada recarga, e um clique em
    // marca chamaria pushState duas vezes (o Voltar passaria a exigir dois cliques).
    if (root.getAttribute('data-sbb-ready') === 'true') return;
    root.setAttribute('data-sbb-ready', 'true');

    var levels = root.querySelectorAll('[data-sbb-level]');
    var crumbs = root.querySelector('[data-sbb-crumbs]');
    var crumbBrand = root.querySelector('[data-sbb-crumb-brand]');
    var crumbModel = root.querySelector('[data-sbb-crumb-model]');
    var sepBrand = root.querySelector('[data-sbb-sep-brand]');
    var sepModel = root.querySelector('[data-sbb-sep-model]');
    var basePath = root.getAttribute('data-base-path') || window.location.pathname;

    // Por root, não global. Como `window.__sbbNavigated` nunca era zerado, bastava um
    // clique em qualquer lugar da página para que toda re-renderização posterior
    // — inclusive a do theme editor ao recarregar a section — forçasse scroll.
    var navigated = false;

    function params() {
      var q = new URLSearchParams(window.location.search);
      return {
        brand: q.get('sbb_brand') || '',
        model: q.get('sbb_model') || ''
      };
    }

    function findLevel(type, brand, model) {
      for (var i = 0; i < levels.length; i++) {
        var el = levels[i];
        if (el.getAttribute('data-sbb-level') !== type) continue;
        if (brand !== undefined && el.getAttribute('data-brand-handle') !== brand) continue;
        if (model !== undefined && el.getAttribute('data-model-handle') !== model) continue;
        return el;
      }
      return null;
    }

    function show(el) {
      for (var i = 0; i < levels.length; i++) {
        levels[i].hidden = levels[i] !== el;
      }
    }

    function setCrumb(node, sep, text, href) {
      if (!node) return;
      if (!text) {
        node.hidden = true;
        if (sep) sep.hidden = true;
        return;
      }
      node.hidden = false;
      if (sep) sep.hidden = false;
      node.textContent = text;
      if (href && node.tagName === 'A') node.setAttribute('href', href);
    }

    function render() {
      var p = params();
      var target = null;
      var brandTitle = '';
      var modelTitle = '';

      if (p.brand && p.model) {
        target = findLevel('years', p.brand, p.model);
      } else if (p.brand) {
        target = findLevel('models', p.brand, undefined);
      } else {
        target = findLevel('brands', undefined, undefined);
      }

      // Marca ou modelo que não existe no menu cai no estado de erro,
      // em vez de renderizar uma tela em branco.
      if (!target) target = findLevel('notfound', undefined, undefined);

      if (target) {
        brandTitle = target.getAttribute('data-brand-title') || '';
        modelTitle = target.getAttribute('data-model-title') || '';
        show(target);
      }

      if (crumbs) crumbs.hidden = !p.brand;
      setCrumb(
        crumbBrand,
        sepBrand,
        brandTitle,
        basePath + '?sbb_brand=' + encodeURIComponent(p.brand)
      );
      setCrumb(crumbModel, sepModel, modelTitle, null);

      // Foco no topo do bloco ao trocar de nível, para leitores de tela
      // e para o usuário não ficar perdido no meio da página.
      if (navigated && root.scrollIntoView) {
        root.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }

    function rememberBike(link) {
      var url = new URL(link.href, window.location.origin);
      var brand = url.searchParams.get('sbb_brand');
      var model = url.searchParams.get('sbb_model');
      var year = url.searchParams.get('sbb_year');
      if (!brand && !model) return;

      try {
        window.localStorage.setItem(
          STORAGE_KEY,
          JSON.stringify({
            brand: brand || '',
            model: model || '',
            year: year || '',
            path: url.pathname,
            url: url.pathname + url.search
          })
        );
      } catch (e) {
        // localStorage indisponível (modo privado / cookies bloqueados):
        // os parâmetros na URL já bastam para o banner da primeira tela.
      }
    }

    root.addEventListener('click', function (event) {
      var link = event.target.closest('a[data-sbb-go]');
      if (!link) return;

      var kind = link.getAttribute('data-sbb-go');

      if (kind === 'products') {
        rememberBike(link);
        return; // navegação normal para a coleção
      }

      // Cliques com modificador ou botão do meio seguem o comportamento do navegador.
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
        return;
      }

      event.preventDefault();
      navigated = true;
      window.history.pushState({}, '', link.getAttribute('href'));
      render();
    });

    // O listener de clique vive no próprio root e morre junto com ele. O de popstate é
    // global, então precisa ser removido à mão quando a section sai do DOM.
    function onPopState() {
      navigated = true;
      render();
    }
    window.addEventListener('popstate', onPopState);
    root.sbbTeardown = function () {
      window.removeEventListener('popstate', onPopState);
      root.removeAttribute('data-sbb-ready');
    };

    render();
  }

  function bootWithin(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var roots = scope.querySelectorAll('[data-shop-by-bike]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  function boot() {
    bootWithin(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // No theme editor, inicializa apenas a section recarregada — não o documento inteiro.
  document.addEventListener('shopify:section:load', function (event) {
    bootWithin(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target || !event.target.querySelectorAll) return;
    var roots = event.target.querySelectorAll('[data-shop-by-bike]');
    for (var i = 0; i < roots.length; i++) {
      if (typeof roots[i].sbbTeardown === 'function') roots[i].sbbTeardown();
    }
  });
})();
